var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.497 10.289H19.5C20.051 10.289 20.499 10.7633 20.5 11.3491C20.508 14.1892 19.475 16.8634 17.591 18.8772C15.708 20.8911 13.2 22.0044 10.529 22.0129H10.5C7.83898 22.0129 5.33598 20.9156 3.44899 18.9198C1.55499 16.9176 0.507985 14.2509 0.499985 11.4108C0.491985 8.5697 1.52499 5.89659 3.40899 3.88272C5.29199 1.86884 7.79999 0.755577 10.471 0.74707C11.266 0.75983 12.076 0.844893 12.852 1.04267C13.388 1.18089 13.719 1.75507 13.589 2.32606C13.46 2.89598 12.917 3.24687 12.383 3.11077C11.762 2.95127 11.103 2.88429 10.477 2.87365C8.33998 2.88003 6.33298 3.77107 4.82698 5.38196C3.31998 6.99284 2.49398 9.13218 2.49998 11.4044C2.50599 13.6767 3.34399 15.8097 4.85898 17.412C6.36898 19.008 8.37098 19.8863 10.5 19.8863H10.523C12.66 19.8799 14.667 18.9889 16.173 17.378C17.68 15.7661 18.506 13.6278 18.5 11.3555C18.499 10.7686 18.945 10.2901 19.497 10.289ZM6.79319 10.6284C7.18419 10.2126 7.81619 10.2126 8.20719 10.6284L10.4512 13.0144L16.7482 5.36294C17.1122 4.9238 17.7432 4.87701 18.1592 5.26405C18.5742 5.65003 18.6162 6.32203 18.2522 6.76436L11.2522 15.2707C11.0702 15.4918 10.8102 15.6226 10.5332 15.6333H10.5002C10.2352 15.6333 9.98119 15.5216 9.79319 15.3217L6.79319 12.1318C6.40219 11.7161 6.40219 11.0441 6.79319 10.6284Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValid);
export default __webpack_public_path__ + "static/media/valid.01187c510531e68771c529b77cfa9a13.svg";
export { ForwardRef as ReactComponent };